import React from "react";
import { View } from "react-native";
import { useFragment } from "react-relay";
import { graphql } from "relay-runtime";
import { CreatedBySubject_actor$key } from "./__generated__/CreatedBySubject_actor.graphql";
import { SignedActorCompact, SignedActorText } from "./Actor/SignedActor";

export function CreatedBySubject(props: { actor: CreatedBySubject_actor$key }) {
  const actor = useFragment(
    graphql`
      fragment CreatedBySubject_actor on Actor {
        ...SignedActorCompact_actor
      }
    `,
    props.actor
  );

  return (
    <View style={{ flexDirection: "row", alignItems: "center" }}>
      <SignedActorCompact signedActor={actor} />
    </View>
  );
}
